import { useNavigate, useParams } from "react-router-dom";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Footer from "../../components/molecules/footer/Footer";
import Header from "../../components/molecules/header/Header";
import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { imprimirSolicitud } from "../../components/services/ConcursosService";
import { cargarAutoFirma, firmar } from "../../utils/AutoScriptUtils";


const PresentarSolicitudConcurso = () => {
    const navigate = useNavigate();
    const params = useParams()
    const [loading, setLoading] = useState(true);
    const [solicitud, setSolicitud] = useState(null);
    const [blobFile, setBlobFile] = useState(null)

    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const base64ToBlob = (base64, mimeType = "application/pdf") => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    };


    useEffect(() => {
        setLoading(false);
        imprimirSolicitud(params.idCon, params.idSol).then((data) => {

            const file = new Blob([data], { type: "application/pdf" });
            setBlobFile(file)
            const blobUrl = URL.createObjectURL(file);
           
            setSolicitud(blobUrl);
            setLoading(true)
        })
    }, [params]);


    return (<>
        <Header />
        <div
            className="container-fluid d-flex flex-column card mt-5"
            id="inicio"
            role="main"
            data-landmark-index="4"
        >
            {loading ? (
                <div className="my-auto">
                    <div className="container-login fondo">
                        <div className="tituloSolicitud">
                            <div className="d-flex align-items-center flex-column">
                                {/* <h2 className="tituloPagina">
                                    Presentar
                                </h2> */}
                            </div>

                            <div className="datosPersonalesCarrera d-flex flex-column m-2">
                                <h3 className="tituloPagina noBg">3. Presentar</h3>
                                <div className="separador"></div>

                                <div className="formulario">
                                    <Formik
                                        initialValues={{}}
                                        validate={() => ({})}
                                        onSubmit={() => {

                                        }}
                                    >
                                        {() => (
                                            <Form>
                                                <div className="card p-3 my-3">
                                                    <div className="row justify-content-center">
                                                        {/* Columna botones */}
                                                        <div className="mb-3 row justify-content-center">
                                                            <div className="col col-md-4 mb-1">
                                                                <button
                                                                    id="firmarSolicitudCarrera"
                                                                    className="btn btn-outline-primary "
                                                                    type="button"
                                                                    onClick={async () => {
                                                                        cargarAutoFirma();

                                                                        // Convertir blob a base64 correctamente
                                                                        const soloBase64 = await blobToBase64(blobFile);

                                                                        const coordenadas = {
                                                                            x1: 310,
                                                                            y1: 160,
                                                                            x2: 560,
                                                                            y2: 250,
                                                                            page: 1
                                                                        };

                                                                        // Llamar a AutoFirma
                                                                        firmar(coordenadas, soloBase64, (firmaB64) => {
                                                                            if (firmaB64 && typeof firmaB64 === "string") {

                                                                                // const pdfFirmadoDataUrl = `data:application/pdf;base64,${firmaB64}`;

                                                                                // Convertir a blob para poder mostrarlo en <object>
                                                                                const blobFirmado = base64ToBlob(firmaB64);

                                                                                const blobUrlFirmado = URL.createObjectURL(blobFirmado);

                                                                                setSolicitud(blobUrlFirmado);
                                                                                setLoading(true);
                                                                            } else {
                                                                                alert("Error al obtener la firma.");
                                                                            }
                                                                        });
                                                                    }}

                                                                >
                                                                    <i className="fa-solid fa-pencil"></i> Firmar
                                                                </button>
                                                            </div>




                                                        </div>

                                                        {/* Columna PDF */}
                                                        <div className="col-12 col-md-8">
                                                            <object
                                                                data={solicitud}
                                                                type="application/pdf"
                                                                height="500"
                                                                width="100%"
                                                                aria-label="PDF del borrador"
                                                                className="rounded"
                                                                name="sol"
                                                            >
                                                                <span className="rojo">Error al obtener el PDF</span>
                                                            </object>
                                                        </div>
                                                    </div>

                                                    {/* Botón volver */}
                                                    <div className=" col-md-2 my-2">
                                                        <button
                                                            id="volver"
                                                            className="btnRed rojo btn-danger rounded w-md-auto"
                                                            type="button"
                                                            onClick={() => {
                                                                navigate(`/concurso/${params.idCon}`);
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-rotate-left"></i> Volver
                                                        </button>
                                                    </div>
                                                </div>


                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
                    <SpinnerCircle />
                </div>
            )}
        </div>
        <Footer />
    </>)
}

export default PresentarSolicitudConcurso;